module.exports = __webpack_public_path__ + "static/img/phone.bb7d215.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview/phone.png
// module id = Dt6R
// module chunks = 1